import Joi from "joi-browser";
import _, { isEmpty } from "lodash";
import moment from "moment";
import { createRef } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { updateTeamPlayChallenge, updateTeamPlayChallengeReceived } from "store/telegram";

//  Images
import closeIcon from "include/images/close-icon.svg";
import filterIcon from "include/images/filter-icon.svg";
import emptyIcon from "include/images/nrf.svg";
import carrentIcon from "include/images/carrent-icon.svg";
import loadingIcon from "include/images/loader-grey.svg";
import plusIcon from "include/images/plus.svg";
import userIcon from "include/images/user.png";

//  Components
import AlertError from "common/alert/alertError";
import AlertSuccess from "common/alert/alertSuccess";
import Form from "common/form/form";
import NextButton from "common/form/submitButton";
import Header from "common/header";
import Loader from "common/loader";
import SideBar from "common/sidebar";
import { TELEGRAM_PLAYER_VS_PLAYER_PRIZE_TYPES } from "utils/constants";
import { Dropdown } from "react-bootstrap";
import AlertModal from "common/alert/alertModal";
import {
  deletePvPContest,
  deletePvpReceived,
  getPvP,
  loadPvPGames,
  updatePvPContest,
  updatePvpReceived,
} from "store/pvp";

class PvpGamesListing extends Form {
  ref = createRef(null);
  refCsv = createRef(null);
  state = {
    data: {
      title: "",
      winnerUserName: "",
    },
    id: "",
    loadingOptions: false,
    loadingMain: false,
    loadingDelete: false,
    loading: false,
    showDeleteModal: false,
    showAddModal: false,
    cancelId: "",
    editData: null,
    showHistory: false,
    objectId: "",
    object: null,
    page: 1,
    statusInd: null,
    loadingStatus: false,
    showLeaderboard: false,
    showWinners: false,
    challenge: null,
    winnersCSV: [],
    loadingCsv: false,
    sweeps: null,
    errors: {},
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (!this.props.getPvP.loading && this.props.getPvP.loading !== prevProps.getPvP.loading)
      this.ref.current.complete();

    if (this.props.getPvP.loading && this.props.getPvP.loading !== prevProps.getPvP.loading)
      this.ref.current.continuousStart();

    if (this.state.showAddModal !== prevState.showAddModal && !this.state.showAddModal) {
      setTimeout(() => {
        this.setState({ editData: null });
      }, 500);
    }
    const params = new URLSearchParams(this.props.location.search);
    const status = params.get("status");
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevStatus = prevParams.get("status");

    if (status !== prevStatus) this.getPvpGames();
  };
  componentDidMount = () => {
    this.getPvpGames();
  };
  getPvpGames = () => {
    const searchParams = new URLSearchParams(this.props.location.search);
    const status = searchParams.get("status");
    const page = this.state.page;
    this.setState({ loadingMain: true });
    this.props.loadPvPGames({ page, status }, (res) => {
      this.setState({
        loadingMain: false,
      });
    });
  };

  toggleAddModal = (e) => {
    if (e) e.preventDefault();
    this.setState({ showAddModal: !this.state.showAddModal });
  };

  onChange = (e) => {
    const data = { ...this.state.data };
    data[e.target.name] = e.target.value;
    this.setState({ data });
  };
  handleCancel = (e) => {
    this.setState({ loadingDelete: true });
    this.props.deletePvPContest(this.state.cancelId, (challengeRes) => {
      if (challengeRes.status === 200) {
        toast(<AlertSuccess message="Deleted!" />, {
          containerId: 1,
        });
        this.props.deletePvpReceived(this.state.cancelId);
        this.cancelModalToggle();
        this.setState({ loadingDelete: false });
      } else {
        toast(<AlertError message={challengeRes.data && challengeRes.data.message} />, {
          containerId: 1,
        });
        this.cancelModalToggle();
        this.setState({ loadingDelete: false });
      }
    });
  };
  changeStatus = (e) => {
    this.setState({ loadingStatus: true });
    const payLoad = { isActive: this.state.statusInd };
    delete payLoad._id;
    this.props.updatePvPContest(this.state.statusChangeId, payLoad, (statusRes) => {
      this.setState({
        loadingStatus: false,
      });
      if (statusRes.status === 200) {
        this.props.updatePvpReceived(statusRes.data.data);
      } else {
        toast(<AlertError message={statusRes.data && statusRes.data.message} />, {
          containerId: 1,
        });
      }
    });
  };
  cancelModalToggle = (e) => {
    if (e) e.preventDefault();
    this.setState({ showDeleteModal: !this.state.showDeleteModal });
  };
  searchFilters = (e) => {
    if (e) e.preventDefault();

    this.setState({ loadingFilters: true });
    var params = _.pickBy(this.state.data, function (value, key) {
      return !_.isEmpty(value);
    });
    params.page = this.state.page;
    this.props.loadPvPGames(params, (challengeRes) => {
      this.setState({
        loadingFilters: false,
      });
      if (challengeRes?.status === 200) {
        const data = { ...this.state.data };
        const appliedFilters = {};
        Object.keys(this.state.data).forEach((key) => {
          if (!_.isEmpty(data[key])) {
            appliedFilters[key] = data[key];
          }
        });
        this.setState({ appliedFilters });
      }
    });
  };
  resetFilters = (e) => {
    e.preventDefault();
    this.setState(
      {
        data: {
          title: "",
          winnerUserName: "",
        },
      },
      () => this.searchFilters(),
    );
  };
  removeFilter = (type) => {
    const data = this.state.data;
    data[type] = "";
    this.setState({ data }, this.searchFilters);
  };
  getOrdinalSuffix(number) {
    const remainder100 = number % 100;
    const remainder10 = number % 10;

    // Handle special cases for 11, 12, and 13
    if (remainder100 >= 11 && remainder100 <= 13) {
      return `${number}th`;
    }

    // Handle general cases based on last digit
    switch (remainder10) {
      case 1:
        return `${number}st`;
      case 2:
        return `${number}nd`;
      case 3:
        return `${number}rd`;
      default:
        return `${number}th`;
    }
  }

  render() {
    const { pvpGameList, pvpGameTotalCount } = this.props.getPvP;
    return (
      <>
        <Header history={this.props.history} />
        <Loader loaderRef={this.ref} />
        <div className="page-wrapper add-dev-server-wrapper">
          <SideBar page="telegram-mini-app-player-vs-player-games" />
          <div className="main-content-wrapper position-relative">
            <div className="mcw-header d-flex align-items-center">
              <h1>Player vs Player Games Played {pvpGameTotalCount > 0 && `(${pvpGameTotalCount})`}</h1>
              <div className="filter-menu-box d-flex align-items-center ms-auto">
                {/* <div className="fmb-box">
                  <a
                    href="#!"
                    className="filter-link-box"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        showFilters: !this.state.showFilters,
                      });
                    }}
                  >
                    <img src={filterIcon} /> <span>Filters</span>
                  </a>
                </div> */}
              </div>
            </div>
            <div className="fwc-wrapper">
              {this.state.showFilters && (
                <div className="fwc-head ">
                  <div className="fwc-inner">
                    <ul className="filter-mode-list question-filter-mode-list d-flex flex-wrap align-items-center">
                      <li className="flex-fill">
                        <div className="fml-box">{this.renderInput("bgGameName", "BG Game Name")}</div>
                      </li>{" "}
                      <li className="flex-fill">
                        <div className="fml-box">{this.renderInput("playerOneUserName", "Player One Username")}</div>
                      </li>{" "}
                      <li className="flex-fill">
                        <div className="fml-box">{this.renderInput("playerTwoUserName", "Player Two Username")}</div>
                      </li>
                    </ul>
                    <div className="fwc-btn d-flex align-items-center justify-content-end">
                      <NextButton
                        handleSubmit={this.resetFilters}
                        classData="btn-text pointer"
                        label="Reset"
                        loading={this.state.loadingReset}
                      />
                      <NextButton
                        handleSubmit={() => {
                          this.setState(
                            {
                              page: 1,
                            },
                            () => this.searchFilters(),
                          );
                        }}
                        classData="btn btn-primary btn-sm"
                        label="Search"
                        loading={this.state.loadingFilters}
                      />
                    </div>
                  </div>{" "}
                  {!isEmpty(this.state.appliedFilters) && (
                    <div className="filter-tag-container d-flex align-items-center ">
                      <div className="fwc-left">
                        <div className="filter-tag-list">
                          <p>filter applied :</p>
                          {Object.keys(this.state.appliedFilters).map((key) => (
                            <div className="filter-tag-item">
                              <span className="camelCase">
                                {key === "bgGameName"
                                  ? "Bg Game Name"
                                  : key === "playerOneUserName"
                                  ? "Player One User Name"
                                  : key === "playerTwoUserName"
                                  ? "Player Two User Name"
                                  : key}
                              </span>{" "}
                              :{" "}
                              {key === "status" ? this.state.appliedFilters[key].name : this.state.appliedFilters[key]}
                              <a
                                href="#!"
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.setState(
                                    {
                                      data: { ...this.state.data, [key]: "" },
                                      page: 1,
                                    },
                                    this.searchFilters,
                                  );
                                }}
                              >
                                <img src={closeIcon} alt="" />
                              </a>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}{" "}
              <div className="fwc-body">
                {!this.state.loadingMain && (
                  <div className="table-responsive">
                    {pvpGameList?.length === 0 ? (
                      <div className="fwc-body">
                        <div className="no-record-found-container">
                          <div className="nfr-box">
                            <img src={emptyIcon} alt="No Record Found" />
                            <div className="nrf-text">
                              <h5>No Records Found!</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <table className="table large-table">
                        <thead>
                          <tr>
                            <th>Title</th>
                            <th>Game</th>
                            <th>Player 1</th>
                            <th>Player 2</th>
                            <th>Winner</th>
                            <th>Entry Fee</th>
                            <th>Prize</th>
                            <th style={{ width: 80 }}>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pvpGameList?.map((challenge, i) => (
                            <tr>
                              <td>
                                <Link
                                  to="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.setState({ editData: challenge }, () => {
                                      this.toggleAddModal();
                                    });
                                  }}
                                  className={`td-text-box d-flex align-items-center ${
                                    challenge?.status !== "scheduled" && "pointer-none"
                                  }`}
                                >
                                  {challenge?.contest?.name}
                                </Link>
                              </td>
                              <td>
                                <Link
                                  to="#!"
                                  className={`td-text-box d-flex align-items-center ${
                                    challenge?.status !== "scheduled" && "pointer-none"
                                  }`}
                                >
                                  {challenge?.contest?.bgGame?.name}
                                </Link>
                              </td>
                              <td>
                                <div className="td-text-box d-flex align-items-center">
                                  {challenge?.users[0]?.userName ? (
                                    <div className="text-capitalize">{challenge?.users[0]?.userName}</div>
                                  ) : (
                                    <div className="text-capitalize">
                                      {challenge?.users[0]?.firstName + " " + challenge?.users[0]?.lastName}
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="td-text-box d-flex align-items-center">
                                  {challenge?.users[1]?.userName ? (
                                    <div className="text-capitalize">{challenge?.users[1]?.userName}</div>
                                  ) : (
                                    <div className="text-capitalize">
                                      {challenge?.users[1]?.firstName + " " + challenge?.users[1]?.lastName}
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td>
                                <span>
                                  {challenge?.winner && (
                                    <div className="td-img-group d-flex align-items-start ">
                                      <div className="td-img round-img m-right-2">
                                        {challenge?.winner?.image ? (
                                          <img
                                            src={process.env.REACT_APP_CDN + challenge?.winner?.image.small}
                                            alt=""
                                          />
                                        ) : (
                                          <img src={userIcon} alt="" />
                                        )}
                                      </div>

                                      <div className="-mt-8">
                                        {/* First + Last Name */}
                                        {challenge?.winner?.firstName && challenge?.winner?.lastName && (
                                          <>
                                            <span className="me-2">
                                              {challenge.winner.firstName + " " + challenge.winner.lastName}
                                            </span>
                                            <br />
                                          </>
                                        )}

                                        {/* Username */}
                                        {challenge?.winner?.userName && (
                                          <span className="me-2">{challenge.winner.userName}</span>
                                        )}
                                        <br />
                                        {/* Email */}
                                        {challenge?.winner?.email && (
                                          <span className="me-2">{challenge.winner.email}</span>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </span>
                              </td>
                              <td>
                                {challenge?.contest?.entryFee}{" "}
                                {TELEGRAM_PLAYER_VS_PLAYER_PRIZE_TYPES[challenge?.contest?.entryFeeType]}
                              </td>
                              <td>
                                {challenge?.contest?.prize}{" "}
                                {TELEGRAM_PLAYER_VS_PLAYER_PRIZE_TYPES[challenge?.contest?.prizeType]}
                              </td>
                              <td className="ust-tag">
                                <Dropdown className="custom-dropdown">
                                  <Dropdown.Toggle
                                    id="tdDropdownOne"
                                    className="custom-dropdown-toggle"
                                    disabled={this.state.loadingStatus}
                                  >
                                    <span
                                      className={`w-100 text-center d-block camelCase ${
                                        challenge.winner ? "active" : "inactive"
                                      } ${this.state.loadingStatus && "pointer-none"}`}
                                    >
                                      {this.state.loadingStatus && this.state.statusChangeId === challenge._id ? (
                                        <img
                                          src={loadingIcon}
                                          alt="loading..."
                                          style={{ width: 20 }}
                                          className="fa-spin"
                                        />
                                      ) : challenge.winner ? (
                                        "Completed"
                                      ) : (
                                        "Not Completed"
                                      )}
                                    </span>
                                  </Dropdown.Toggle>
                                </Dropdown>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
                {!this.state.loadingMain &&
                  !(this.state.page === 1 && pvpGameList?.length === 0) &&
                  !(pvpGameList?.length < 20 && this.state.page === 1) && (
                    <div className="page-pagination">
                      <ul className="pagination  justify-content-end">
                        <li className="page-item">
                          <a
                            class={`page-link ${this.state.page === 1 && "disabled"}`}
                            href="#!"
                            aria-label="Previous"
                            onClick={(e) => {
                              e.preventDefault();
                              if (this.state.page > 1) {
                                this.setState({ page: this.state.page - 1 }, () => this.searchFilters());
                              }
                            }}
                          >
                            <svg
                              width="8"
                              height="14"
                              viewBox="0 0 8 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M7 13L1 7L7 1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </li>
                        <li className="page-item active">
                          <a
                            className="page-link"
                            href="#!"
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            {this.state.page}
                          </a>
                        </li>
                        {pvpGameList?.length >= 20 && (
                          <li className="page-item">
                            <a
                              className="page-link"
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({ page: this.state.page + 1 }, () => this.searchFilters());
                              }}
                            >
                              {this.state.page + 1}
                            </a>
                          </li>
                        )}
                        <li className="page-item">
                          <a
                            class={`page-link ${pvpGameList?.length < 20 && "disabled"}`}
                            href="#!"
                            aria-label="Next"
                            onClick={(e) => {
                              e.preventDefault();
                              this.setState({ page: this.state.page + 1 }, () => this.searchFilters());
                            }}
                          >
                            <svg
                              width="8"
                              height="14"
                              viewBox="0 0 8 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M1 13L7 7L1 1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>

        <AlertModal
          alertModalToggle={this.cancelModalToggle}
          alertModalShow={this.state.showDeleteModal}
          alertType="Yes"
          title="Alert"
          description="Are you sure you want to delete this Team Play Challenge?"
          onPress={this.handleCancel}
          loading={this.state.loadingDelete}
        />
        {this.state.showAddModal && <div className="modal-backdrop show fade" onClick={this.toggleAddModal}></div>}
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  loadPvPGames: (params, callback) => dispatch(loadPvPGames(params, callback)),
  updatePvpReceived: (payLoad) => dispatch(updatePvpReceived(payLoad)),
  updatePvPContest: (id, data, callback) => dispatch(updatePvPContest(id, data, callback)),
  deletePvPContest: (id, callback) => dispatch(deletePvPContest(id, callback)),
  deletePvpReceived: (payLoad) => dispatch(deletePvpReceived(payLoad)),
});
const mapStateToProps = (state) => ({
  getPvP: getPvP(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PvpGamesListing));
